import TruckAndDriverBaseController from "./truck_and_driver_base_controller"

export default class extends TruckAndDriverBaseController {
  static outlets = [
    "truck-gate-in--form-manager",
    "truck-gate-in--validations",
  ]
  static targets = [
    'errors',
    'truckDriver',
  ]

  async handleTruckDriverChange() {
    const driverId = this.truckDriverTarget.value
    if (driverId && driverId.trim() !== '') {
      this.clearPresenceError()
    }
    await this.validateSelection(driverId)
    this.updateSubmissionLock()
  }

  buildValidateUrl(driverId) {
    return `/validations/truck_visit_eligibility/validate_driver/${driverId}`
  }

  validatePresence(event) {
    if (!this.requiredValue) return
    const driverId = this.truckDriverTarget.value

    if (driverId && driverId.trim() !== '') {
      this.clearPresenceError()
    } else {
      event.preventDefault()
      this.setPresenceError('You must select a truck driver.')
    }
    this.updateSubmissionLock()
  }

  updateSubmissionLock() {
    const driverId = this.truckDriverTarget.value
    if (this.requiredValue && (!driverId || driverId.trim() === "")) {
      this.lockSubmission("driverRequired")
    } else {
      this.unlockSubmission("driverRequired")
    }
  }

  /**
   * Sets the driver select when the truck company
   * has a sticky driver.
   */
  setStickyDriver(id, name, selectText = null) {
    const current = this.truckDriverTarget.value
    if (!id || (current && current.trim() !== '')) return

    this.updateSelect2(this.truckDriverTarget, id, name, selectText)
    // Clear any presence error and refresh submission lock.
    this.clearPresenceError()
    this.updateSubmissionLock()
  }
}
